
  import { Vue, Component } from "vue-property-decorator";
  import Roles from "@/entities/Roles";
  import SectionTitle from "@/views/auth/common/SectionTitle.vue";
  import UiButton from "@/components/button/ui-button.vue";

  @Component({
    components: {
      UiButton,
      SectionTitle,
    },
  })
  export default class SignUpRoles extends Vue {
    roles = Roles;
  }
